import { object, string } from 'yup';
import i18n from '../../themes/i18n';

export const createLetterValidations = object({
  letterType: string().required(i18n.t('required-field') || ''),
  language: string().required(i18n.t('required-field') || ''),
});
